var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcTinnitus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.1,
    height: 68.101,
    viewBox: "0 0 68.1 68.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1447",
    "data-name": "Grupo 1447",
    transform: "translate(483.621 -8187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1441",
    "data-name": "Grupo 1441",
    transform: "translate(188.776 -166.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1598",
    "data-name": "Trazado 1598",
    d: "M2.7,14.16A2.7,2.7,0,0,1,1.187,9.228L12.825,1.374a2.7,2.7,0,0,1,4.043,1.313L18.617,7.5,29.249,1.283a2.7,2.7,0,1,1,2.724,4.655L18.55,13.791a2.7,2.7,0,0,1-3.894-1.405L12.981,7.779,4.208,13.7A2.71,2.71,0,0,1,2.7,14.16",
    transform: "translate(-655 8371.001)",
    fill: "#02ceff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1599",
    "data-name": "Trazado 1599",
    d: "M21.257,12.651H2.7a2.7,2.7,0,1,1,0-5.394h18.56a2.7,2.7,0,0,1,0,5.394",
    transform: "translate(-654.999 8381.768)",
    fill: "#02ceff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1600",
    "data-name": "Trazado 1600",
    d: "M13.021,12.656a2.623,2.623,0,0,1-1.885-.809,2.672,2.672,0,0,1-.812-1.888A2.834,2.834,0,0,1,10.54,8.9a2.379,2.379,0,0,1,.6-.86A2.727,2.727,0,0,1,12,7.451a2.771,2.771,0,0,1,1.564-.135,3.627,3.627,0,0,1,.515.135c.159.081.294.162.458.243a5.11,5.11,0,0,1,.4.351,2.721,2.721,0,0,1,.6.86,2.888,2.888,0,0,1,.216,1.054,2.658,2.658,0,0,1-.812,1.888,2.686,2.686,0,0,1-1.915.809",
    transform: "translate(-637.48 8381.774)",
    fill: "#02ceff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1601",
    "data-name": "Trazado 1601",
    d: "M21.257,16.084H2.7a2.7,2.7,0,1,1,0-5.394h18.56a2.7,2.7,0,0,1,0,5.394",
    transform: "translate(-654.999 8387.594)",
    fill: "#02ceff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1602",
    "data-name": "Trazado 1602",
    d: "M13.021,16.084a2.747,2.747,0,0,1-1.885-.782,2.624,2.624,0,0,1-.6-2.94,2.255,2.255,0,0,1,.6-.89,2.686,2.686,0,0,1,2.425-.725,3.285,3.285,0,0,1,.515.132,5.186,5.186,0,0,1,.458.27,4.6,4.6,0,0,1,.4.324,2.7,2.7,0,0,1-1.915,4.612",
    transform: "translate(-637.48 8387.594)",
    fill: "#02ceff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1442",
    "data-name": "Grupo 1442",
    transform: "translate(-1454.216 2860.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_975",
    "data-name": "Grupo 975",
    transform: "translate(970.595 5326.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1732",
    "data-name": "Rect\\xE1ngulo 1732",
    fill: "none",
    stroke: "#1de9b6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.1,
    height: 68.1,
    rx: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 67.1,
    height: 67.1,
    rx: 13.5,
    fill: "none"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTinnitus);
export default __webpack_public_path__ + "static/media/ic_tinnitus.00773746a5a359e7b7dc6e1b7287e745.svg";
export { ForwardRef as ReactComponent };